import { useExternalParams } from 'shared/hooks';
import { DateTime } from 'luxon';
import { PaymentsFilters } from './use-payments-filters.types';
import { PaymentOrderBy } from '../payments.types';

const initialValues = {
  creationDate: {
    initialValue: DateTime.now(),
    type: 'date',
  },
  workerId: {
    initialValue: undefined,
    type: 'string',
  },
  invoiceReference: {
    initialValue: undefined,
    type: 'string',
  },
  status: {
    initialValue: undefined,
    type: 'string_array',
  },
  dueDate: {
    initialValue: undefined,
    type: 'date',
  },
  order: {
    initialValue: 'desc',
    type: 'string',
  },
  orderBy: {
    initialValue: PaymentOrderBy.creationDate,
    type: 'string',
  },
} as const;

export const usePaymentsPage = () => {
  const [params, setParams] = useExternalParams(initialValues);

  const filters: PaymentsFilters = {
    creationDate: params.creationDate,
    workerId: params.workerId,
    invoiceReference: params.invoiceReference,
    status: params.status,
    dueDate: params.dueDate,
    order: params.order as 'asc' | 'desc',
    orderBy: params.orderBy as PaymentOrderBy,
  };

  const selectedFilterCount = [
    filters.creationDate,
    filters.workerId,
    filters.invoiceReference,
    filters.status,
    filters.dueDate,
  ].filter((value) => !!value).length;

  return {
    filters,
    setFilters: setParams,
    selectedFilterCount,
  };
};
